import './action-bar.scss'

import { defineComponent } from 'vue'
import { faPlusSquare } from '@fortawesome/free-regular-svg-icons'
import {
    faClipboardCheck,
    faCogs,
    faExclamation,
    faList,
    faSlash,
    faWifi
} from '@fortawesome/free-solid-svg-icons'


import { CommonRoutes, AuditRoutes } from '@skinsoft/const'
import { OfflineDataFetcher, OfflineDataUpdateCacher } from '@skinsoft/offline'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { SynchroModal } from '@skinsoft/offline-mode'
import { ClickableIconWithLegend, SideMenu } from '@skinsoft/ui'
import { OnlineStatusIndicator } from '@skinsoft/offline-mode/src/components/online-status-indicator'
import { FORCE_CLOSE_MENU_TOPIC } from '../../../busTopics'
import { RecordEditMenu } from '../record-edit-screen/record-edit-menu'
import { TOGGLE_MENU_TOPIC } from '@skinsoft/bus/src/busTopics'
import { WorkspaceType } from '@skinsoft/types'

export const ActionBar = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        clickableIconWithLegend: ClickableIconWithLegend,
        sOnlineStatusIndicator: OnlineStatusIndicator,
        sRecordEditMenu: RecordEditMenu,
        sSideMenu: SideMenu,
        sSynchroModal: SynchroModal
    },
    template: require('./action-bar.html'),
    data() {
        return {
            movementCount: 0,
            taskCount: 0,
            menuOpened: false,
            routeHasMenu: false,
            toggleSideMenuTopic: TOGGLE_MENU_TOPIC,
            forceCloseMenuTopic: FORCE_CLOSE_MENU_TOPIC,
            isSyncError: false,
            // Icons
            homeIcon: faList,
            menuIcon: faCogs,
            wifiIcon: faWifi,
            slashIcon: faSlash,
            errorIcon: faExclamation,
            archiveIcon: faClipboardCheck,
            newItemsIcon: faPlusSquare,
        }
    },
    computed: {
        routeToNewlyCreated(): string {
            const workspaceType = localStorage.getItem("workspaceType")

            if(workspaceType) {
                switch(workspaceType) {
                    case WorkspaceType.archive:
                        // TODO WHEN ARCHIVES ARE IMPLEMENTED (Make new component using archive search screen)
                        return '/' + AuditRoutes.NEW_ITEMS
                    case WorkspaceType.specimen:
                        return '/' + AuditRoutes.NEW_SPECIMENS
                    default:
                        return '/' + AuditRoutes.NEW_ITEMS
                }
            }

            return ''
        },
    },
    created() {
        this.subscribeToBus(TOGGLE_MENU_TOPIC, () => {
            this.menuOpened = !this.menuOpened;
        })
        this.fetchSyncError()
    },
    methods: {
        toggleMenu() {
            this.emitOnBus(TOGGLE_MENU_TOPIC);
        },
        async fetchSyncError() {
            this.isSyncError = await OfflineDataUpdateCacher.isPushError() || await OfflineDataFetcher.isSyncError();
        },
        checkCurrentRoute(routeName) {
            return this.$route.path === routeName;
        },
        goToHome() {
            this.$router.push({ name: AuditRoutes.AUDIT_HOME })
        },
        goToCampaigns() {
            this.$router.push({ name: AuditRoutes.CAMPAIGN_SEARCH })
            this.emitOnBus(FORCE_CLOSE_MENU_TOPIC)
        },
        goToNewlyCreated() {
            const workspaceType = localStorage.getItem("workspaceType")

            if(workspaceType) {
                switch(workspaceType) {
                    case WorkspaceType.archive:
                        // TODO WHEN ARCHIVES ARE IMPLEMENTED (Make new component using archive search screen)
                        this.$router.push({ name: AuditRoutes.NEW_ITEMS})
                        break
                    case WorkspaceType.specimen:
                        this.$router.push({ name: AuditRoutes.NEW_SPECIMENS})
                        break
                    default:
                        this.$router.push({ name: AuditRoutes.NEW_ITEMS})
                        break
                }
            }
            this.emitOnBus(FORCE_CLOSE_MENU_TOPIC)
        },
        toogleSynchroModal() {
            (this.$refs.synchroModal as InstanceType<typeof SynchroModal>).open()
        },
    },
    watch: {
        '$route': {
            handler($route) {
                this.routeHasMenu = !!$route.matched.find(match => !!match.components.actionMenu);
                if (!this.routeHasMenu) {
                    this.emitOnBus(FORCE_CLOSE_MENU_TOPIC);
                }
                this.menuOpened = false;
            },
            immediate: true,
            deep: true,
        },
    },
})
